import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { Area1Set, Area2Set } from "../../App";
import { photo } from "../../cesiumsetting";
import { MultiSetting } from "../../kashikabuttons";

export const GeographTab = ({ meta, meta2 }) => {
  const { area1set, setArea1Set } = useContext(Area1Set);
  const { area2set, setArea2Set } = useContext(Area2Set);
  let params = useParams();

  return (
    <>
      <main className="w-full flex flex-wrap mt-2">
        <div className="w-[20vw] pointer-events-auto cursor-pointer text-black font-extrabold">
          <MultiSetting
            modeset={1}
            fullviewerset={1}
            rendouset={true}
            syukurenset={false}
            map1set={photo}
            map2set={photo}
            static2map1set={meta}
            static2map2set={meta}
            rotate1set={false}
            rotate2set={false}
            area1set={
              (area1set && area1set !== "日本全国" && !area1set.endsWith("地方") && area1set) ||
              (area2set && area2set !== "日本全国" && !area2set.endsWith("地方") && area2set) ||
              "福岡県糸島市"
            }
            area2set={
              (area2set && area2set !== "日本全国" && !area2set.endsWith("地方") && area2set) ||
              (area1set && area1set !== "日本全国" && !area1set.endsWith("地方") && area1set) ||
              "福岡県糸島市"
            }
            to={"/map"}
            no={meta.no}
            no2={meta.no}
          >
            <div className="bg-gradient-to-r from-rose-400 via-rose-500 to-rose-600 hover:bg-gradient-to-br focus:ring-4 focus:ring-rose-300 dark:focus:ring-rose-800 text-xs md:text-sm lg:text-base px-4 py-2 h-full text-center rounded-tl-2xl rounded-tr-2xl">
              <span className="hidden md:contents">自分で</span>地域
              <span className="hidden md:contents">を選ぶ</span>
            </div>
          </MultiSetting>
        </div>

        <div className="w-[20vw] pointer-events-auto cursor-pointer text-black font-extrabold">
          <MultiSetting
            modeset={2}
            fullviewerset={0}
            rendouset={true}
            syukurenset={false}
            map1set={photo}
            map2set={photo}
            // static2map1set={meta}
            // static2map2set={meta}
            rotate1set={false}
            rotate2set={false}
            area1set={
              (area1set && area1set !== "日本全国" && !area1set.endsWith("地方") && area1set) ||
              (area2set && area2set !== "日本全国" && !area2set.endsWith("地方") && area2set) ||
              "福岡県糸島市"
            }
            area2set={
              (area2set && area2set !== "日本全国" && !area2set.endsWith("地方") && area2set) ||
              (area1set && area1set !== "日本全国" && !area1set.endsWith("地方") && area1set) ||
              "福岡県糸島市"
            }
            year1set={meta.year1 || meta.year5}
            year2set={meta.year5}
            to={"/map"}
            no={meta.no}
            no2={meta.no}
          >
            <div className="bg-gradient-to-r from-orange-400 via-orange-500 to-orange-600 hover:bg-gradient-to-br focus:ring-4 focus:ring-orange-300 dark:focus:ring-orange-800 text-xs md:text-sm lg:text-base px-4 py-2 h-full text-center rounded-tl-2xl rounded-tr-2xl">
              <span className="hidden md:contents">地域の</span>昔
              <span className="hidden md:contents">と比べる</span>
            </div>
          </MultiSetting>
        </div>

        <div className="w-[20vw] pointer-events-auto cursor-pointer text-black font-extrabold">
          <MultiSetting
            modeset={3}
            fullviewerset={0}
            // rendouset={false}
            // syukurenset={true}
            map1set={photo}
            map2set={photo}
            static2map1set={meta}
            static2map2set={meta2}
            rotate1set={false}
            rotate2set={false}
            area1set={
              (area1set && area1set !== "日本全国" && !area1set.endsWith("地方") && area1set) ||
              (area2set && area2set !== "日本全国" && !area2set.endsWith("地方") && area2set) ||
              "福岡県糸島市"
            }
            area2set={
              (area2set && area2set !== "日本全国" && !area2set.endsWith("地方") && area2set) ||
              (area1set && area1set !== "日本全国" && !area1set.endsWith("地方") && area1set) ||
              "福岡県糸島市"
            }
            to={"/map"}
            no={meta.no}
            no2={meta.no}
            // no2={meta2.no}
          >
            <div className="bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 hover:bg-gradient-to-br focus:ring-4 focus:ring-yellow-300 dark:focus:ring-yellow-800 text-xs md:text-sm lg:text-base px-4 py-2 h-full text-center rounded-tl-2xl rounded-tr-2xl">
              <span className="hidden md:contents">他の地域と</span>比べ
              <span className="hidden md:contents">る</span>
            </div>
          </MultiSetting>
        </div>

        {!meta.tenkei_mode && (
          <div className="w-[20vw] pointer-events-auto cursor-pointer text-black font-extrabold">
            {/* <MultiSetting
              modeset={8}
              fullviewerset={0}
              rendouset={true}
              syukurenset={false}
              map1set={photo}
              map2set={photo}
              static2map1set={meta}
              static2map2set={meta2}
              rotate1set={false}
              rotate2set={false}
              area1set={
                (area1set && area1set !== "日本全国" && !area1set.endsWith("地方") && area1set) ||
                (area2set && area2set !== "日本全国" && !area2set.endsWith("地方") && area2set) ||
                "福岡県糸島市"
              }
              area2set={
                (area2set && area2set !== "日本全国" && !area2set.endsWith("地方") && area2set) ||
                (area1set && area1set !== "日本全国" && !area1set.endsWith("地方") && area1set) ||
                "福岡県糸島市"
              }
              year1set={meta.year5}
              year2set={meta.year5}
              to={"/map"}
              no={meta.no}
              no2={meta2.no}
            >
            <div className="bg-gradient-to-r from-lime-400 via-lime-500 to-lime-600 hover:bg-gradient-to-br focus:ring-4 focus:ring-lime-300 dark:focus:ring-lime-800 text-xs md:text-sm lg:text-base px-4 py-2 h-full text-center rounded-tl-2xl rounded-tr-2xl">
              <span className="hidden md:contents">地域を</span>多角<span className="hidden md:contents">的に見る</span>
            </div> */}
            <MultiSetting
              modeset={4}
              fullviewerset={1}
              rendouset={false}
              syukurenset={true}
              map1set={photo}
              map2set={photo}
              static2map1set={meta}
              static2map2set={meta}
              rotate1set={false}
              rotate2set={false}
              area1set={meta.tenkei_city}
              area2set={area2set}
              to={"/map"}
              no={meta.no}
            >
              <div className="bg-gradient-to-r from-lime-400 via-lime-500 to-lime-600 hover:bg-gradient-to-br focus:ring-4 focus:ring-lime-300 dark:focus:ring-lime-800 text-xs md:text-sm lg:text-base px-4 py-2 h-full text-center rounded-tl-2xl rounded-tr-2xl">
                事例<span className="hidden md:contents">とその解説</span>
              </div>

            </MultiSetting>
          </div>
        )}
        {meta.tenkei_mode == 6 && (
          <div className="w-[20vw] pointer-events-auto cursor-pointer text-black font-extrabold">
            {/* <MultiSetting
              modeset={8}
              fullviewerset={0}
              rendouset={true}
              syukurenset={false}
              map1set={photo}
              map2set={photo}
              static2map1set={meta}
              static2map2set={meta2}
              rotate1set={false}
              rotate2set={false}
              area1set={
                (area1set && area1set !== "日本全国" && !area1set.endsWith("地方") && area1set) ||
                (area2set && area2set !== "日本全国" && !area2set.endsWith("地方") && area2set) ||
                "福岡県糸島市"
              }
              area2set={
                (area2set && area2set !== "日本全国" && !area2set.endsWith("地方") && area2set) ||
                (area1set && area1set !== "日本全国" && !area1set.endsWith("地方") && area1set) ||
                "福岡県糸島市"
              }
              year1set={meta.year1 || meta.year5}
              year2set={meta.year5}
              to={"/map"}
              no={meta.no}
              no2={meta.no}
              // no2={"11-03"}
            > */}
            <MultiSetting
              modeset={6}
              fullviewerset={0}
              rendouset={true}
              syukurenset={false}
              map1set={photo}
              map2set={photo}
              static2map1set={meta}
              static2map2set={meta}
              rotate1set={false}
              rotate2set={false}
              area1set={meta.tenkei_city}
              area2set={meta.tenkei_city_2}
              to={"/map"}
              no={meta.no}
              year1set={meta.year1 || meta.year5}
              year2set={meta.year5}
            >
              <div className="bg-gradient-to-r from-lime-400 via-lime-500 to-lime-600 hover:bg-gradient-to-br focus:ring-4 focus:ring-lime-300 dark:focus:ring-lime-800 text-xs md:text-sm lg:text-base px-4 py-2 h-full text-center rounded-tl-2xl rounded-tr-2xl">
                {/* <span className="hidden md:contents">地域を</span>多角<span className="hidden md:contents">的に見る</span> */}
                事例<span className="hidden md:contents">とその解説</span>
              </div>
            </MultiSetting>
          </div>
        )}
        {meta.tenkei_mode == 7 && (
          <div className="w-[20vw] pointer-events-auto cursor-pointer text-black font-extrabold">
              {/* <MultiSetting
                modeset={8}
                fullviewerset={0}
                rendouset={true}
                syukurenset={false}
                map1set={photo}
                map2set={photo}
                static2map1set={meta}
                static2map2set={meta2}
                rotate1set={false}
                rotate2set={false}
                area1set={
                  (area1set && area1set !== "日本全国" && !area1set.endsWith("地方") && area1set) ||
                  (area2set && area2set !== "日本全国" && !area2set.endsWith("地方") && area2set) ||
                  "福岡県糸島市"
                }
                area2set={
                  (area2set && area2set !== "日本全国" && !area2set.endsWith("地方") && area2set) ||
                  (area1set && area1set !== "日本全国" && !area1set.endsWith("地方") && area1set) ||
                  "福岡県糸島市"
                }
                year1set={meta.year1 || meta.year5}
                year2set={meta.year5}
                to={"/map"}
                no={meta.no}
                no2={meta.no}
              > */}
            <MultiSetting
              modeset={7}
              fullviewerset={1}
              rendouset={false}
              syukurenset={true}
              map1set={photo}
              map2set={photo}
              static2map1set={meta}
              static2map2set={meta}
              rotate1set={false}
              rotate2set={false}
              area1set={meta.tenkei_city}
              area2set={meta.tenkei_city_2}
              to={"/map"}
              no={meta.no}
            >
              <div className="bg-gradient-to-r from-lime-400 via-lime-500 to-lime-600 hover:bg-gradient-to-br focus:ring-4 focus:ring-lime-300 dark:focus:ring-lime-800 text-xs md:text-sm lg:text-base px-4 py-2 h-full text-center rounded-tl-2xl rounded-tr-2xl">
                {/* <span className="hidden md:contents">地域を</span>多角<span className="hidden md:contents">的に見る</span> */}
                事例<span className="hidden md:contents">とその解説</span>
              </div>
            </MultiSetting>
          </div>
        )}

        {meta.kokudo_onoff && (
          <div className="w-[20vw] pointer-events-auto cursor-pointer text-black font-extrabold">
            <MultiSetting
              modeset={5}
              fullviewerset={1}
              rendouset={false}
              syukurenset={true}
              map1set={photo}
              map2set={photo}
              static2map1set={meta}
              static2map2set={meta}
              rotate1set={false}
              rotate2set={false}
              area1set={"日本全国"}
              area2set={area2set}
              to={"/map"}
              no={meta.no}
            >
              <div className="bg-gradient-to-r from-teal-400 via-teal-500 to-teal-600 hover:bg-gradient-to-br focus:ring-4 focus:ring-teal-300 dark:focus:ring-teal-800 text-xs md:text-sm lg:text-base px-4 py-2 h-full text-center rounded-tl-2xl rounded-tr-2xl">
                広域<span className="hidden md:contents">で見る</span>
              </div>
            </MultiSetting>
          </div>
        )}
        {!meta.kokudo_onoff && (
          <div className="w-[20vw] pointer-events-auto text-green-200 font-extrabold">
            <div className="bg-gradient-to-r from-teal-400 via-teal-500 to-teal-600 text-xs md:text-sm lg:text-base px-4 py-2 h-full text-center rounded-tl-2xl rounded-tr-2xl">
              <span className="hidden md:contents">広域表示</span>なし
            </div>
          </div>
        )}

        {/* タブ下のライン */}
        {/* <div className="w-full absolute mt-20 md:mt-24 z-30 pointer-events-none"> */}
        {params.mode == 1 && (
          <div className="w-full h-2 bg-gradient-to-r from-rose-400 via-rose-500 to-rose-600 hover:bg-gradient-to-br focus:ring-4 focus:ring-rose-300 dark:focus:ring-rose-800"></div>
        )}
        {params.mode == 2 && (
          <>
            <div className="w-full h-2 bg-gradient-to-r from-orange-400 via-orange-500 to-orange-600 hover:bg-gradient-to-br focus:ring-4 focus:ring-orange-300 dark:focus:ring-orange-800"></div>
            <div className="fixed top-28 bottom-0 left-1/2">
              <div className="w-1 bg-gray-800 h-full"></div>
            </div>
          </>
        )}
        {params.mode == 3 && (
          <>
            <div className="w-full h-2 bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 hover:bg-gradient-to-br focus:ring-4 focus:ring-yellow-300 dark:focus:ring-yellow-800"></div>
            <div className="fixed top-28 bottom-0 left-1/2">
              <div className="w-1 bg-gray-800 h-full"></div>
            </div>
          </>
        )}
        {params.mode == 4 && (
          <div className="w-full h-2 bg-gradient-to-r from-lime-400 via-lime-500 to-lime-600 hover:bg-gradient-to-br focus:ring-4 focus:ring-lime-300 dark:focus:ring-lime-800"></div>
        )}
        {params.mode == 5 && (
          <div className="w-full h-2 bg-gradient-to-r from-teal-400 via-teal-500 to-teal-600 hover:bg-gradient-to-br focus:ring-4 focus:ring-teal-300 dark:focus:ring-teal-800"></div>
        )}
        {params.mode == 6 && (
          <>
            <div className="w-full h-2 bg-gradient-to-r from-lime-400 via-lime-500 to-lime-600 hover:bg-gradient-to-br focus:ring-4 focus:ring-lime-300 dark:focus:ring-lime-800"></div>
            <div className="fixed top-28 bottom-0 left-1/2">
              <div className="w-1 bg-gray-800 h-full"></div>
            </div>
          </>
        )}
        {params.mode == 7 && (
          <>
            <div className="w-full h-2 bg-gradient-to-r from-lime-400 via-lime-500 to-lime-600 hover:bg-gradient-to-br focus:ring-4 focus:ring-lime-300 dark:focus:ring-lime-800"></div>
            <div className="fixed top-28 bottom-0 left-1/2">
              <div className="w-1 bg-gray-800 h-full"></div>
            </div>
          </>
        )}
        {params.mode == 8 && (
          <>
            <div className="w-full h-2 bg-gradient-to-r from-lime-400 via-lime-500 to-lime-600 hover:bg-gradient-to-br focus:ring-4 focus:ring-lime-300 dark:focus:ring-lime-800"></div>
            <div className="fixed top-28 bottom-0 left-1/2">
              <div className="w-1 bg-gray-800 h-full"></div>
            </div>
          </>
        )}
        {/* </div> */}
      </main>
    </>
  );
};
